export default __webpack_public_path__ + "static/media/Acao1_recorte.18bd492b.webp";